export default class LanguageHelper {
    static formatMessage
}
